module.exports = __webpack_public_path__ + "img/cancel.2b002a89.svg";